import { MultiSelectList } from './MultiSelectList';
import { SingleSelectList } from './SingleSelectList';
import { useMetadataField } from '../useMetadataField';
export function AllowedValuesList() {
    const { property } = useMetadataField();
    const { allowedValues, isMultiSelect } = property;
    const data = allowedValues === null || allowedValues === void 0 ? void 0 : allowedValues.reduce((all, current) => {
        const { text, value, groupValues } = current;
        const localizedGroupValues = (groupValues === null || groupValues === void 0 ? void 0 : groupValues.map((groupValue) => ({ text: groupValue.text, value: groupValue.value }))) || [];
        return [...all, { text, value }, ...localizedGroupValues];
    }, []);
    if (!data)
        return null;
    if (isMultiSelect) {
        return <MultiSelectList data={data}/>;
    }
    return <SingleSelectList data={data}/>;
}
